import {Box} from "@material-ui/core"
import React, {useState} from "react"

import imagePlaceholder from "../../../../../assets/imagePlaceholder.svg"

const ReportImageCard = ({
                           item,
                           handlePreview,
                         }: {
  item: any,
  handlePreview: (item: any) => void,
}) => {
  const [imgSrc, setImgSrc] = useState(item.url || imagePlaceholder)

  return (
    <Box
      style={{
        position: "relative",
        width: "100%",
        paddingTop: "100%", // square aspect ratio
        overflow: "hidden",
        cursor: "pointer",
        borderRadius: 8,
        backgroundColor: "#f5f5f5",
      }}
      onClick={() => handlePreview(item)}
    >
      <img
        src={imgSrc}
        alt={item.title || "Image"}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          objectPosition: "center",
        }}
        onError={() => setImgSrc(imagePlaceholder)} // If load fails, show placeholder
      />
    </Box>
  )
}

export default ReportImageCard
